import { observer } from 'mobx-react-lite';
import {
    Formik,
    Form,
    Field,
    ErrorMessage
} from 'formik';
import { signUpSchema } from '../../../app/common/formValidations/validationSchemes';
import { RegisterSignupForm } from '../../../app/models/user';
import { useStore } from '../../../app/stores/store';
import { Box, Button, FormControl, Grid, TextField, Typography } from '@mui/material';
import { withNavbar } from '../../../app/layout/HOC';
import { useEffectOnce } from 'usehooks-ts';
import { collectionFormStyles } from '../../basicUser/basicUserForms/collectionFormStyles';
import CircularProgress from '@mui/material/CircularProgress';
import ValidationErrors from '../../errors/ValidationErrors';

const SignUpForm = () => {
    const { commonStore, userStore } = useStore();
    const { loading } = userStore;

    useEffectOnce(() => {
        commonStore.resetAppData();
    })

    const initialValues: RegisterSignupForm = {
        fullName: '', email: '', username: '', companyName: '', countryName: '',
        city: '', zipCode: '', street: '', vatNumber: '',
        isTermAndConditionAccepted: false, error: null
    };

    return (
        <Box component="div" sx={{ display: 'flex', justifyContent: 'center', alignContent: 'center', pt: 15 }}>
            <Box component="div" sx={collectionFormStyles.refferalSignUpFormContainer}>
                <Box component="div">
                    <Typography variant="h5" textAlign={'center'} sx={{ p: 2 }}>Sign up</Typography>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={signUpSchema}
                        onSubmit={(values, { setSubmitting, setErrors }) => {
                            userStore.addNewRegisteration(values)
                                .catch(error => setErrors({ error }))
                            setSubmitting(false);
                        }}
                    >
                        {({ values,
                            handleChange,
                            handleBlur,
                            errors,
                            isValid
                        }) => {
                            return (
                                <Form className="w100" autoComplete="off">
                                    <Grid container rowSpacing={1}>
                                        <Grid item xs={12}>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>Email</Typography>
                                                <Field
                                                    type="text"
                                                    component={TextField}
                                                    id="email"
                                                    name="email"
                                                    placeholder="Email"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.email}
                                                    variant="outlined"
                                                />
                                                <ErrorMessage className='errorText' name="email" component="div" />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>User Name</Typography>
                                                <Field
                                                    type="text"
                                                    component={TextField}
                                                    id="username"
                                                    name="username"
                                                    placeholder="username"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.username}
                                                    variant="outlined"
                                                />
                                                <ErrorMessage className='errorText' name="username" component="div" />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>Full Name</Typography>
                                                <Field
                                                    type="text"
                                                    component={TextField}
                                                    id="fullName"
                                                    name="fullName"
                                                    placeholder="Fullname"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.fullName}
                                                    variant="outlined"
                                                />
                                                <ErrorMessage className='errorText' name="fullName" component="div" />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>Country Name</Typography>
                                                <Field
                                                    type="text"
                                                    component={TextField}
                                                    id="countryName"
                                                    name="countryName"
                                                    placeholder="Country Name"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.countryName}
                                                    variant="outlined" />
                                                <ErrorMessage className='errorText' name="countryName" component="div" />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>Company Name</Typography>
                                                <Field
                                                    type="text"
                                                    component={TextField}
                                                    id="companyName"
                                                    name="companyName"
                                                    placeholder="companyName"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.companyName}
                                                    variant="outlined" />
                                                <ErrorMessage className='errorText' name="companyName" component="div" />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>City</Typography>
                                                <Field
                                                    type="text"
                                                    component={TextField}
                                                    id="city"
                                                    name="city"
                                                    placeholder="city"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.city}
                                                    variant="outlined"
                                                />
                                                <ErrorMessage className='errorText' name="city" component="div" />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>Street</Typography>
                                                <Field
                                                    type="text"
                                                    component={TextField}
                                                    id="street"
                                                    name="street"
                                                    placeholder="street"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.street}
                                                    variant="outlined"
                                                />
                                                <ErrorMessage className='errorText' name="street" component="div" />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>Zip Code</Typography>
                                                <Field
                                                    type="text"
                                                    component={TextField}
                                                    id="zipCode"
                                                    name="zipCode"
                                                    placeholder="zipCode"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.zipCode}
                                                    variant="outlined"
                                                />
                                                <ErrorMessage className='errorText' name="zipCode" component="div" />
                                            </FormControl>
                                            <FormControl fullWidth>
                                                <Typography variant='caption'>VAT Number</Typography>
                                                <Field
                                                    type="text"
                                                    component={TextField}
                                                    id="vatNumber"
                                                    name="vatNumber"
                                                    placeholder="Vat Number"
                                                    fullWidth
                                                    margin="normal"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.vatNumber}
                                                    variant="outlined"
                                                />
                                                {/* <ErrorMessage className='errorText' name="vatNumber" component="div" /> */}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                    <FormControl fullWidth>
                                        <label>
                                            <Field
                                                type="checkbox"
                                                id="isTermAndConditionAccepted"
                                                name="isTermAndConditionAccepted"
                                            />
                                            &nbsp; <a href='/termsandconditions' target='_blank' className='errorTextBlack'>I agreed to the Terms and conditions</a>
                                        </label>
                                        <ErrorMessage className='errorText' name="isTermAndConditionAccepted" component="div" />
                                    </FormControl>
                                    <ErrorMessage
                                        name='error' render={() =>
                                            <ValidationErrors errors={errors.error} />
                                        }
                                    />
                                    {loading ? <CircularProgress /> :
                                        <Button sx={{ mt: 2 }} type="submit" fullWidth variant="contained" disabled={!isValid}> Save</Button>
                                    }
                                </Form>
                            );
                        }}
                    </Formik>
                </Box>
            </Box>
        </Box>

    )
}
const SignUpFormPage = withNavbar(observer(SignUpForm));
export default SignUpFormPage;